var map = {
	"./EN/AdminPanel": 796,
	"./EN/AdminPanel.json": 796,
	"./EN/Common": 738,
	"./EN/Common.json": 738,
	"./EN/DevPanel": 164,
	"./EN/DevPanel.json": 164,
	"./EN/FirstConfig": 869,
	"./EN/FirstConfig.json": 869,
	"./EN/Projects": 873,
	"./EN/Projects.json": 873,
	"./EN/Sidebar": 997,
	"./EN/Sidebar.json": 997,
	"./ES/AdminPanel": 749,
	"./ES/AdminPanel.json": 749,
	"./ES/Common": 960,
	"./ES/Common.json": 960,
	"./ES/DevPanel": 29,
	"./ES/DevPanel.json": 29,
	"./ES/FirstConfig": 890,
	"./ES/FirstConfig.json": 890,
	"./ES/Projects": 56,
	"./ES/Projects.json": 56,
	"./ES/Sidebar": 466,
	"./ES/Sidebar.json": 466,
	"./FR/AdminPanel": 669,
	"./FR/AdminPanel.json": 669,
	"./FR/Common": 955,
	"./FR/Common.json": 955,
	"./FR/DevPanel": 925,
	"./FR/DevPanel.json": 925,
	"./FR/FirstConfig": 154,
	"./FR/FirstConfig.json": 154,
	"./FR/Projects": 264,
	"./FR/Projects.json": 264,
	"./FR/Sidebar": 74,
	"./FR/Sidebar.json": 74,
	"./translations_lang": 518,
	"./translations_lang.json": 518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 550;